/*
Door Lock Sets
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Lock Sets'
const id = 'r932ZWJTsJYQycUSWVFZ'

export default {
  name,
  id,
  filters,
  headers,
  form
}
